// Integer math for the simulation. The sim stores only integers so every
// JavaScript engine computes the same night bit for bit.
// Fixed point: 1 world unit = ONE (Q12).
export const ONE = 4096;

export const idiv = (a, b) => Math.trunc(a / b);
export const clampi = (v, lo, hi) => (v < lo ? lo : v > hi ? hi : v);

// Floor square root for non-negative safe integers.
export function isqrt(n) {
  if (n <= 0) return 0;
  let r = Math.floor(Math.sqrt(n));
  while (r * r > n) r -= 1;
  while ((r + 1) * (r + 1) <= n) r += 1;
  return r;
}

export const len = (x, y) => isqrt(x * x + y * y);

// Integer vector of length `l` pointing along (x, y); [0, 0] for a zero vector.
export function withLength(x, y, l) {
  const d = len(x, y);
  return d === 0 ? [0, 0] : [idiv(x * l, d), idiv(y * l, d)];
}

// Units (float, authoring only) to fixed point.
export const fx = u => Math.round(u * ONE);
